import { requestJson, assertOk } from "./storeApi"

export async function fetchInventory() {
    const { response, payload } = await requestJson("/inventory/index", {
        method: "GET",
        credentials: "include",
    });

    return assertOk(response, payload, "Failed to load inventory");
}

export async function createInventoryAdjustment({ variantId, quantity, referenceType = "Inventory", referenceId = 0, expiresAt = null }) {
    const { response, payload } = await requestJson("/inventory", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            variant_id: variantId,
            quantity,
            reference_type: referenceType,
            reference_id: referenceId,
            expires_at: expiresAt,
        }),
    });

    return assertOk(response, payload, "Failed to update inventory");
}